import { createAction } from 'redux-actions';

import { FileDTO } from '../../services/types/ApiTypes';

const ns = 'fileView/';

export const setPdfToOpenAction = createAction<FileDTO | null>(`${ns}SET_PDF_TO_OPEN`);
